<template>
  <nav class="navbar fixed-bottom bg-none nx-nav-footer">
    <div class="container-fluid justify-content-end">
      <button
        class="btn btn-success nx-btn-floating lh-1"
        type="button"
        @click="onCurrentFlightClick"
        v-if="singleHoleMode && hasFlights"
      >
        {{ $t("message.jumpToCurrentFlight") }}
        <br />
        <small>
          {{ $t("message.onHoleN", { item: selectedSingleHole ?? 1 }) }}</small
        >
      </button>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "NavFooter",
  props: {
    onCurrentFlightClick: Function,
    hasFlights: Boolean,
  },
  computed: {
    ...mapGetters({
      singleHoleMode: "navigation/getSingleHoleMode",
      selectedSingleHole: "navigation/getSelectedSingleHole",
    }),
  },
};
</script>

<style lang="scss">
.nx-nav-footer {
  min-height: 47px;
}

.nx-btn-floating {
  border-radius: 3em !important;
  padding: 5px 20px !important;
  box-shadow: 0px 17px 10px -10px rgba(0, 0, 0, 0.4);
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 15px;
}
</style>
